import {
  RedoButton,
  type RedoButtonProps,
} from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";

export interface SetupGuideModalFooterAction {
  text: string;
  dataTestId?: string;
  disabled?: boolean;
  IconLeading?: RedoButtonProps["IconLeading"];
  IconTrailing?: RedoButtonProps["IconTrailing"];
  onClick?: RedoButtonProps["onClick"];
  pending?: boolean;
}

export const SetupGuideModalFooterActions = memo(
  function SetupGuideModalFooterActions({
    primaryAction,
    secondaryAction,
    size = "lg",
  }: {
    primaryAction: SetupGuideModalFooterAction;
    secondaryAction?: SetupGuideModalFooterAction | null;
    size?: RedoButtonProps["size"];
  }) {
    return (
      <Flex align="center" gap="sm" justify="space-between" w="full">
        <Flex align="center" gap="sm">
          {secondaryAction ? (
            <RedoButton
              hierarchy="secondary"
              size={size}
              {...secondaryAction}
            />
          ) : null}
        </Flex>

        <RedoButton hierarchy="primary" size={size} {...primaryAction} />
      </Flex>
    );
  },
);
